<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="page1" v-show="showPage === 1">
      <!-- <div class="m-bg-cover"></div> -->
      <div class="m-content">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <!-- 下拉刷新 -->
          <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
            <div class="m-box" v-for="(item, index) in dataList" :key="index">
              <p class="m-title">{{ item.roomName }}</p>
              <div class="m-title-text">
                <div class="m-subject">考试科目：{{ item.examSubject }}</div>
                <div class="m-select" @click="goTo(item)">查询考场</div>
              </div>
            </div>
          </van-pull-refresh>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPage: 1,
      loading: false,
      finished: false,
      isLoading: false,
      setId: '',
      token: window.localStorage.getItem('token'),
      selectData: {},
      dataList: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      roomDetails: [
        {
          label: '考试',
          value: ''
        },
        {
          label: '准考证号',
          value: ''
        },
        {
          label: '姓名',
          value: ''
        },
        {
          label: '证件号码',
          value: ''
        },
        {
          label: '科目',
          value: ''
        },
        {
          label: '考点',
          value: ''
        },
        {
          label: '考场',
          value: ''
        },
        {
          label: '座位号',
          value: ''
        },
        {
          label: '考试时间',
          value: ''
        },
        {
          label: '考点信息',
          value: ''
        },
      ]
    }
  },
  created() { },
  mounted() { },
  methods: {
    onLoad() {
      console.log('加载')
      if (this.isLoading) {
        this.isLoading = false
      } else {
        this.pageNum++
      }
      this.getList()
    },
    onRefresh() {
      this.loading = true
      this.dataList = []
      this.pageNum = 1
      this.onLoad()
    },
    getList() {
      this.loading = false
      this.http.getRequest({
        url: '/app/user/getExamRoomList',
        msg: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
        success: (res) => {
          this.count = res.total
          this.dataList = this.dataList.concat(res.rows)
          this.loading = false
          if (this.dataList.length >= this.count) {
            this.finished = true
          } else {
            this.finished = false
          }
        }
      })
    },
    goTo(data) {
      sessionStorage.setItem('selectData', JSON.stringify(data))
      this.$router.push({ path: '/examination/room/details' })
      // this.selectData = data
      // this.setId = data.registerId
      // this.roomDetails[0].value = this.selectData.examName
      // this.roomDetails[1].value = this.selectData.admissionNumb
      // this.roomDetails[2].value = this.selectData.userName
      // this.roomDetails[3].value = this.selectData.idCardNum
      // this.roomDetails[4].value = this.selectData.examSubject
      // this.roomDetails[5].value = this.selectData.siteName
      // this.roomDetails[6].value = this.selectData.roomName
      // this.roomDetails[7].value = this.selectData.seatNum
      // this.roomDetails[8].value = this.selectData.startTime
      // this.roomDetails[9].value = this.selectData.address
      // this.showPage = 2
    },
    download() {
      window.open(`/api/app/exam/downLoadAdmission/${this.setId}?token=${this.token}`)
    },
  },
}
</script>
<style lang="less" scoped>
.page {
  // width: 100%;
  // height: 100%;
  background: #F4F6F9;

  .m-bg-cover {
    position: absolute;
    width: 100%;
    height: 180px;
    background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
    z-index: -1;
  }

  .m-content {
    padding: 30px 12px 15px 12px;

    .m-box {
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      padding: 12px;
      margin-bottom: 16px;

      .m-title {
        font-size: 15px;
        color: #1D232D;
        font-weight: bold;
        line-height: 18px;

      }

      .m-title-text {
        color: #2B6CF9;
        font-size: 15px;
        margin-top: 12px;
        display: flex;
        justify-content: space-between;

        .m-subject {
          height: 32px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 32px;
        }

        .m-select {
          width: 100px;
          height: 32px;
          background: #F2F6FF;
          border-radius: 4px;
          font-size: 13px;
          font-weight: 400;
          color: #2B6CF9;
          line-height: 32px;
          text-align: center;
        }
      }
    }
  }

  .page2 {
    width: 100%;
    height: 100%;
    padding: 16px 12px;
    box-sizing: border-box;
  }

  .room-details {
    width: 100%;
    height: auto;
    background-color: #fff;
    border-radius: 4px;
    padding: 16px 12px;
    box-sizing: border-box;
    margin-bottom: 40px;
    // overflow: hidden;

    .room-title {
      width: 100%;
      display: flex;
      align-items: center;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #2B6CF9;
      line-height: 20px;
      margin-bottom: 10px;

      .book {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .info-list {
      width: 100%;
      display: flex;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 0;
      box-sizing: border-box;

      .label {
        width: 56px;
        color: #8D8F93;
      }

      .value {
        flex: 1;
        color: #1D232D;
        text-align: right;
      }
    }

  }

  .download-btn {
    width: 100%;
    display: flex;
    justify-content: center;

    .btn {
      width: 144px;
      height: 42px;
      background: linear-gradient(270deg, #3A5AF5 0%, #3E8DF6 100%);
      border-radius: 8px;
      font-weight: bold;
      font-size: 14px;
      text-align: center;
      line-height: 42px;
      color: #fff;
    }
  }
}
</style>